import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import CommandCentre from "./pages/CommandCentre";
import Grants from "./pages/Grants";
import ExecutiveOverview from "./pages/ExecutiveOverview";
import Financial from "./pages/Financial";
import ThematicOverview from "./pages/ThematicOverview";
import GeographicFootprint from "./pages/GeographicFootprint";
import GranteeOverview from "./pages/GranteeOverview";
import DataHealth from "./pages/DataHealth";
import RawData from "./pages/RawData";
import Logics from "./pages/Logics";
import GrantsOverview from "./pages/GrantsOverview";
import StoriesOfChange from "./pages/StoriesOfChange";
import Partners from "./pages/Partners";
import { FilterProvider } from "./context/FilterContext";
import { AuthProvider, useAuth } from "./context/AuthContext";
import axios from "axios";
import "./App.css";

// Send cookies with every request for authentication
axios.defaults.withCredentials = true;

function ProtectedApp() {
  const { user, loading, isLoginBypassed } = useAuth();
  const isRestoringSession = isLoginBypassed && !user;

  if (loading || isRestoringSession) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center px-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#006837] mx-auto mb-3" />
          <p className="text-sm text-slate-700 font-medium">Loading dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <FilterProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<CommandCentre />} />
          <Route path="/grants" element={<Grants />} />
          <Route path="/executive-old" element={<ExecutiveOverview />} />
          <Route path="/financial" element={<Financial />} />
          <Route path="/thematic" element={<ThematicOverview />} />
          <Route path="/geographic" element={<GeographicFootprint />} />
          <Route path="/grantee" element={<GranteeOverview />} />
          <Route path="/impact" element={<Navigate to="/" replace />} />
          <Route path="/data-health" element={<DataHealth />} />
          <Route path="/raw-data" element={<RawData />} />
          <Route path="/logics" element={<Logics />} />
          <Route path="/grant-overview" element={<GrantsOverview />} />
          <Route path="/stories" element={<StoriesOfChange />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/executive" element={<Navigate to="/executive-old" replace />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </FilterProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ProtectedApp />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
